// Port of ios/Sources/Calls/CallScreenPolicy.swift (Kotlin twin `CallScreenPolicy.kt`).
//
// What a call asks of the SCREEN, given where its audio is coming out: never fall asleep while a
// call is up (ringing and connecting count), and blank by proximity only on the earpiece. A browser
// has no earpiece and no proximity sensor, so only the first promise has a web mechanism — the
// Screen Wake Lock — but the rule is kept whole so the twins stay one decision.

export type CallPhase = 'idle' | 'joining' | 'active';
export type CallAudioRoute = 'earpiece' | 'speaker' | 'bluetooth' | 'wiredHeadset';

export interface CallScreenPolicy {
  keepScreenAwake: boolean;
  blankWhenNearFace: boolean;
}

export const CallScreenPolicy = {
  decide(phase: CallPhase, route: CallAudioRoute): CallScreenPolicy {
    const inCall = phase !== 'idle';
    return { keepScreenAwake: inCall, blankWhenNearFace: inCall && route === 'earpiece' };
  },
};
